import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import profilePic from "../../../assets/images/profilePic.svg";
import Pencil from "../../../assets/images/Pencil.svg";
import UpdateProfilePhoto from "./UpdateProfilePhoto.js";
import { FetchUserProfile } from "../../../Actions/MyProfileActions.js";
import UserDetails from "./UserDetails.js";

const Profile = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const { data: profileData } = useSelector((state) => state.profile);

  const profileImage = profileData?.image;

  useEffect(() => {
    dispatch(FetchUserProfile());
  }, [dispatch]);

  return (
    <>
      <div className="name_wrapper">
        <h2 className="edit_name"  id="user-fullname">
          {profileData?.firstName} {profileData?.lastName}
        </h2>
        <div className="edit_profilePic">
          <img src={profileImage || profilePic} alt={`Profile picture of ${profileData?.firstName || "user"}`} />
        </div>
        <div className="name">
          <button onClick={() => setOpen(true)} aria-label="Edit profile photo" aria-describedby="user-fullname">
             <span aria-hidden="true" style={{ display: "inline-block" }}>
                <img src={Pencil} alt="" />
              </span>
            <span className="visually-hidden">Edit profile photo</span>
            <span aria-hidden="true">Edit Photo</span>
          </button>
        </div>
      </div>
      <div className="update_details">
        <UserDetails editData={profileData} />
      </div>
      <UpdateProfilePhoto open={open} setOpen={setOpen} fetchImage={() => dispatch(FetchUserProfile())} />
    </>
  );
};

export default Profile;
